import React, { useState } from "react";
import "./FilmSubmissionForm.css";

function FilmSubmissionForm() {
  const [formData, setFormData] = useState({
    movieName: "",
    productionHouse: "",
    censorDuration: "",
    cinemaDuration: "",
    scriptWriter: "",
    scriptWriterPhone: "",
    screenplay: "",
    screenplayPhone: "",
    dialogue: "",
    dialoguePhone: "",
    director: "",
    directorPhone: "",
    musicDirector: "",
    musicDirectorPhone: "",
    lyricist: "",
    lyricistPhone: "",
    cinematographer: "",
    cinematographerPhone: "",
    editor: "",
    editorPhone: "",
    artDirector: "",
    artDirectorPhone: "",
    choreographer: "",
    choreographerPhone: "",
    soundDesigner: "",
    soundDesignerPhone: "",
    backgroundMusic: "",
    backgroundMusicPhone: "",
    costumeDesigner: "",
    costumeDesignerPhone: "",
    makeupArtist: "",
    makeupArtistPhone: "",
    singers: "",
    songsList: null,
    songsLink: "",
    protagonists: "",
    castList: null,
    censorCertificate: null,
    vimeoLink: "",
    vimeoCredentials: "",
    agree: false,
  });

  const handleChange = async (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file" && files[0]) {
      try {
        const uploadedPath = await uploadFileToServer(files[0]);
        setFormData((prev) => ({
          ...prev,
          [name]: uploadedPath,
        }));
      } catch (error) {
        console.error("File upload failed:", error);
        alert("Failed to upload file. Please try again.");
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const uploadFileToServer = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(
      "https://certatio-prod.zee5.com/certatio/uploadFile/files",
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error("Upload failed: " + response.statusText);
    }

    const data = await response.json();
    console.log("Upload response:", data);
    return data?.path || data?.filePath || data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      applicationId: "042036b9-c041-4cf4-924b-d92cd2a641ee",
      data: {
        ...formData,
      },
    };

    try {
      const response = await fetch(
        "https://certatio-prod.zee5.com/certatio/data/collect",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        alert("Form submitted successfully!");
      } else {
        console.error("API Error:", await response.text());
        alert("API error occurred.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("Network error occurred.");
    }
  };

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      <div className="form-field">
        <label>चित्रपटाचे नाव / Movie Name</label>
        <input
          type="text"
          name="movieName"
          placeholder="Enter movie name"
          value={formData.movieName}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-field">
        <label>निर्मिती संस्था / Production House</label>
        <input
          type="text"
          name="productionHouse"
          placeholder="Enter production house name"
          value={formData.productionHouse}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-field">
        <label>सेन्सॉर संमत चित्रपटाची लांबी / Censor Approved Duration</label>
        <input
          type="time"
          name="censorDuration"
          value={formData.censorDuration}
          onChange={handleChange}
        />
      </div>

      <div className="form-field">
        <label>चित्रपट कालावधी / Cinema Duration</label>
        <input
          type="text"
          name="cinemaDuration"
          placeholder="e.g., 2 hrs 15 mins"
          value={formData.cinemaDuration}
          onChange={handleChange}
        />
      </div>

      {/* Crew Info Fields */}
      {[
        ["scriptWriter", "कथा / Script Writer"],
        ["screenplay", "पटकथा / Screenplay"],
        ["dialogue", "संवाद / Dialogue"],
        ["director", "दिग्दर्शक / Director"],
        ["musicDirector", "संगीत दिग्दर्शक / Music Director"],
        ["lyricist", "गीतकार / Lyricist"],
        ["cinematographer", "छायाचित्रण / Cinematographer"],
        ["editor", "संकलक / Editor"],
        ["artDirector", "कला दिग्दर्शक / Art Director"],
        ["choreographer", "नृत्य दिग्दर्शक / Choreographer"],
        ["soundDesigner", "ध्वनीरेखाटन / Sound Designer"],
        ["backgroundMusic", "पार्श्वसंगीत / Background Music"],
        ["costumeDesigner", "वेशभूषा / Costume Designer"],
        ["makeupArtist", "रंगभूषा / Make-up Artist"],
      ].map(([key, label]) => (
        <div key={key} className="form-field">
          <label>{label}</label>
          <input
            type="text"
            name={key}
            placeholder="Enter name"
            value={formData[key]}
            onChange={handleChange}
          />

          <input
            type="number"
            name={`${key}Phone`}
            placeholder="Enter mobile number"
            value={formData[`${key}Phone`]}
            onChange={handleChange}
          />
        </div>
      ))}

      {/* Singers and uploads */}
      <div className="form-field">
        <label>गायक/गायिका / Singers</label>
        <input
          type="text"
          name="singers"
          placeholder="Enter singers"
          value={formData.singers}
          onChange={handleChange}
        />
      </div>

      <div className="form-field">
        <label>
          गाण्यांची माहिती खालीलप्रमाणे PDF फाईल जोडावी. गाण्याचं नाव, गीतकार,
          संगीतकार आणि गायक
        </label>
        <input type="file" name="songsList" onChange={handleChange} />
      </div>

      <div className="form-field">
        <label>चित्रपटांच्या गाण्यांची लिंक (YouTube/JioSaavn)</label>
        <input
          type="url"
          name="songsLink"
          placeholder="Enter song link"
          value={formData.songsLink}
          onChange={handleChange}
        />
      </div>

      <div className="form-field">
        <label>अभिनेता/अभिनेत्री / Protagonists</label>
        <input
          type="text"
          name="protagonists"
          placeholder="Enter names"
          value={formData.protagonists}
          onChange={handleChange}
        />
      </div>

      <div className="form-field">
        <label>
          पात्र परिचयाची यादी / Complete cast list with character names​
        </label>
        <input type="file" name="castList" onChange={handleChange} />
      </div>

      <div className="form-field">
        <label>Censor Certificate (PDF/Image)</label>
        <input type="file" name="censorCertificate" onChange={handleChange} />
      </div>

      <div className="form-field">
        <label>चित्रपटाची VIMEO लिंक / Vimeo Link</label>
        <input
          type="url"
          name="vimeoLink"
          placeholder="Enter Vimeo link"
          value={formData.vimeoLink}
          onChange={handleChange}
        />
      </div>

      <div className="form-field">
        <label>VIMEO Username & Password</label>
        <input
          type="text"
          name="vimeoCredentials"
          placeholder="Enter Vimeo credentials"
          value={formData.vimeoCredentials}
          onChange={handleChange}
        />
      </div>

      <div className="agree-section">
        <label className="agree-checkbox">
          <input
            type="checkbox"
            name="agree"
            checked={formData.agree}
            onChange={handleChange}
            required
          />{" "}
          <p>
            दिलेली माहिती खरी असून मी ती पडताळून पाहिली आहे. परिक्षकांचा निर्णय
            अंतिम असून तो आम्हाला मान्य असेल, वरील सर्व नियमांचे आम्ही पालन करु.
            मी/आम्ही आमचा / आमचे चित्रपट झी चित्र गौरव पुरस्कारांच्या
            स्पर्धेसाठी दाखल करित आहोत. मी/आम्ही असे जाहीर करतो की मी/आम्ही ‘झी
            मराठी ‘ तर्फे निश्चित करण्यात आलेल्या स्पर्धा प्रक्रियेशी सहमत असून
            परीक्षकांचा निर्णय अंतिम व बंधनकारक असल्याचे मी/आम्ही मान्य करतो. झी
            चित्र गौरव पुरस्कार जाहीर करण्याव्यतिरिक्त ‘झी मराठी ‘वर कोणतीही
            जबाबदारी किंवा बंधन नसल्याचे मला/आम्हांला सांगण्यात आले असून ते
            मला/आम्हाला मान्य आहे. सदर झी चित्र गौरव पुरस्कारांच्या आयोजनासाठी
            मी/आम्ही/आमची संस्था आपणास पूर्ण सहकार्य करेल. चित्रपटाचा content
            आणि KDM, परिक्षणाच्या दिवशी आपण कळविलेल्या वेळी व ठिकाणी
            पोहचविण्यासाठी आम्ही व्यवस्था करु. <br />I agree to the terms and
            conditions of Zee Gaurav Puraskar 2026.
          </p>
        </label>
      </div>

      <button type="submit" className="submit-btn">
        Submit Form
      </button>
    </form>
  );
}

export default FilmSubmissionForm;
